import styled from "styled-components";
import Img from "../../../../assets/images/Buyer_Image.jpg";
import Img2 from "../../../../assets/images/Buyer_Puzzle.jpg";
export const Container = styled.div``;
export const Wrapper = styled.div`
  max-width: 1440px;
  /* padding: 0 clamp(20px, 3.194vw, 46px); */
  margin: 0 auto;
  position: relative;
  p{
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2.759rem;
  }
  @media (max-width: 767px) {
      h2{
        font-size: 1.5rem !important;
      }
    }
`;
const Banner = styled.div`
  h1,
  h2,
  h3,
  h4 {
    font-family: ITC Franklin Gothic Std;
  }
  @media (max-width: 767px) {
      h2{
        font-size: 1.5rem !important;
      }
    }
  p{
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2.759rem;
  }
  background-image: url(${Img});
  width: 100%;
  position: relative;
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  padding: 16px;
  height: 550px;
  display: flex;
  align-items: center;
  @media (max-width: 1023px) {
    height: 285px;
  }
  .quote {
    position: fixed;
    z-index: 99;
    top: 318px;
    right: 0;
    @media (min-width: 1441px) {
      margin-right: calc(50vw - 726px);
    }
    @media (max-width: 1023px) {
      top: 252px;
    }
    @media (max-width: 767px) {
      top: 286px;
    }
    button {
      background-color: #ff0000c7;
      color: #fff;
      border: none;
      padding: 12px;
      font-size: 16px;
      width: 155px;
      margin-top: min(1.75vw, 25px);
    }
  }
  .banner-text {
    margin-left: 6.25vw;
    color: #ffffff;
    background: #00000047;
    padding: 40px;
    @media (max-width: 1023px) {
      padding: 29px;
    }
    /* @media (max-width: 767px) {
      top: 98px;
    } */
    p {
      width: 444px;
      font-size: 1.5rem;
    }
    h2 {
      font-weight: 500;
      /* &.mb-4 {
        margin-bottom: 4px !important;
      } */
    }
  }
  @media (max-width: 1024px) {
    .quote {
      button {
        padding: 8px;
        font-size: 14px;
        width: 155px;
      }
    }
  }
  @media (max-width: 767px) {
    background-size: cover;
    height: 410px;
    padding: 0;
    .banner-text {
      margin-left: -9px;
      /* padding: 5px; */
      /* margin-left: -5px; */
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 28px;
        /* height: 217px; */
        height: 410px;
        /* margin-bottom: 40px; */
      /* padding-bottom: 16px; */
      /* max-width: 307px; */
      p {
        font-size: 22px;
        width: 100%;
        margin-top: -5px;
      }
      h2 {
        font-size: 2rem !important;
        &.mb-4 {
        /* margin-bottom: 8px !important; */
      }
      }
     
    }
    .quote {
      button {
        padding: 4px;
        font-size: 11px;
        width: 132px;
      }
    }
  }
`;
const Expertise = styled.div`
  p{
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2.759rem;
    @media (max-width: 767px) {
        font-size: 1.5rem !important;
    }
  }
  .simplify_process {
    /* padding: 0 0 min(2.45vw, 35px) 0; */
    margin-top: 4vw;
    background-color: #e9ecec;
    ul li:before {
      content: "✓";
      /* margin-right: 16px; */
      position: absolute;
      left: 24px;
    }
    .box-3-wrp {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
      /* .easy{
        margin-bottom: 27px;
      } */
      /* .dedicated2{
        margin-bottom: 27px;
      } */
      @media (max-width: 1024px) {
        gap: 1rem;
        button {
          width: 184px;
        }
      }
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        gap: 1rem;
        padding: 0 16px;
      }

      @media only screen and (max-width: 1024px) {
        /* .text-bg {
          height: 400px !important;
       } */
        ul {
          /* margin-bottom: 68px !important; */
          min-height: 544px;
        }
        .easy{
          margin-bottom: 123px !important;
        }
        .dedicated {
          /* margin-bottom: 43px !important; */
        }
        .dedicated2 {
          margin-bottom: 29px !important;
        }
      }
      @media (max-width: 767px) {
        ul {
          margin-bottom: 15px !important;
        }
        .easy{
          margin-bottom: 0px !important;
        }
        .dedicated2 {
          margin-bottom: 0px !important;
        }
        .dedicated {
          margin-bottom: 0px !important;
        }
        li{
          font-size: 1.2rem !important;
        }
      }

      .box-info {
        background-color: #e3f1fb;
        @media (max-width: 1024px){
          background-color: #f4fafd;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        li {
          /* list-style: disc; */
          margin-left: 44px;
          /* margin-left: 36px; */
          font-size: 19px;
          padding-bottom: 22px;
        }
      }
    }
    .simplify_process_titel {
      padding: 1.2rem;
      h2 {
        text-align: center;
        color: #233354;
      }
    }

    .img-bg {
      background-color: #233354;
      padding: 26px;
      display: flex;
      justify-content: center;
      min-height: 206px;
    }
    .text-bg {
      /* background-color: #e3f1fb; */
      background-color: #f4fafd;
      /* color: #233354; */
      /* padding: 16px; */
      display: grid;
      place-items: center;
      text-align: center;
      padding-bottom: 19px;
      /* border: 2px solid #233354; */
      ul {
        text-align: left;
        margin-bottom: 0;
        padding: 20px 16px 16px 16px;
        color: #0e5789;
        min-height: 345px;
        @media (max-width: 767px){
          padding-top: 0 !important;
        }
      }
      h4 {
        font-size: 32px;
        margin-bottom: 25px;
        background-color: #233354;
        color: #ffffff;
        padding: 20px 16px 16px 16px;
        @media (max-width: 767px){
          font-size: 1.5rem !important;
        }
      }
  
    }
    .item-center-box {
      display: flex;
      justify-content: center;
      background-color: #ffffff;
      padding-bottom: min(2.45vw, 35px);
    }
    @media only screen and (max-width: 1024px) {
      .img-bg {
        padding: 16px;
        min-height: 125px;
        img {
          max-width: 80px;
        }
      }
    }
    @media (max-width: 767px) {
      .simplify_process_titel {
        padding: 22px 12px;
        h2 {
          font-size: 1.5rem !important;
        }
      }
      .img-bg {
        padding: 16px;
        min-height: 100px;
        img {
          max-width: 103px;
        }
      }
    }
  }
  button {
    background-color: #233354;
    font-weight: 400;
    color: rgb(255, 255, 255);
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
`;
const Operation = styled.div`
  p{
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2.759rem;
    @media (max-width: 767px) {
      h2{
        font-size: 1.5rem !important;
      }
    }
  }
  .our_expertise {
    background-color: #e3f1fb;
    width: 100%;
    background-repeat: repeat;
    background-position: center;
    background-size: cover;
    margin: 4vw 0;
    background-image: url(${Img2});
    .Homepage{
      background-color: #ffffff;
      color: #ee0000;
      width: 270px;
      font-weight: 600;
    }

    .expertise_overlay {
      background: linear-gradient(109deg, #ee0000bf 50%, transparent 50%);
      height: 700px;
      color: #ffffff;
      padding: 16px;
      padding-left: 6.25vw;
      padding-right: 6.25vw;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      &.operation{
        background:linear-gradient(109deg, #b40001e0  50%, transparent 50%);
        @media(max-width: 767px){
         background: linear-gradient(180deg, #ee0000c4 102%, #e3f1fb 102%);
        }
      }
      p{
        margin-top: 42px;
      }
      .digital_supplier_img {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 300px;
        margin-right: 78px;
        @media (max-width: 1023px) {
          margin-top: 201px;
          margin-right: 33px;
        }
        @media (max-width: 767px) {
          margin: 0;
          flex-direction: column;
        }

        img {
          max-width: 410px;
          @media (max-width: 1023px) {
            max-width: 250px;
          }
        }
        button {
          background-color: #233354;
          color: rgb(255, 255, 255);
          width: 265px;
          font-weight: 600;
        }
      }
      .max-w {
        max-width: 461px;
        @media (max-width: 1023px) {
          max-width: 264px;
        }
        @media (max-width: 767px){
          p{
            margin-top: 18px;
          }
        }
      }
      .grid {
        display: grid;
        button {
          background-color: #ffffff;
          color: #ee0000;
          width: 270px;
        }
      }
    }
    @media (max-width: 1024px) {
      .expertise_overlay {
        height: 364px;
      }
    }
    @media (max-width: 767px) {
      background-size: cover;
      margin: 5.5vw 3.5vw !important;
      width: auto;
      .expertise_overlay {
        background: linear-gradient(180deg, #ee0000c4 102%, #e3f1fb 102%);
        /* height: 501px; */
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 300px;
        h2 {
          font-size: 20px;
        }
        p {
          font-size: 14px;
          margin-top: 18px;
        }
        .digital_supplier_img {
          img {
            max-width: 290px;
          }
        }
      }
    }
  }
  button {
    font-weight: 400;
    border: none;
    margin-top: min(1.75vw, 25px);
    font-size: 14px;
    padding: 8px 20px;
    width: 250px;
  }
  .Procurement_Solutions {
    .hedding-wrp {
      display: grid;
      align-items: center;
      justify-content: center;
      text-align: center;
      /* margin-bottom: 1vw; */
      margin-top: 4vw;
      margin-bottom: 21px;
      @media (max-width: 767px) {
        margin: 13px 3px;
      }
      h2 {
        text-align: center;
        color: #233354;
        margin-bottom: -4px;
        @media (max-width: 767px){
          font-size: 1.8rem !important;
        }
      }
      p {
        max-width: 946px;
        text-align: center;
        margin-bottom: 0px;
      }
    }
    .Solutions_box {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 3vw;
      @media (max-width: 360px){
        margin: 5.5vw 0vw !important;
      }
      @media (max-width: 767px) {
        grid-template-columns: 1fr;
        margin: 5.5vw 3.5vw;
        width: auto !important;
      }
      .manage{
       font-weight: 700;
       font-size: 41px !important;
       @media (max-width: 767px){
        font-size: 32px !important;
       }
      }
      .gry-bg {
        background-color: #efefef;
        padding: max(2.083vw, 25px);
        display: grid;
        place-items: center;
        min-height: 480px;
        @media (max-width: 767px) {
          min-height: auto;
          padding: max(1.083vw, 15px);
        }
        img {
          max-width: 500px;
          @media (max-width: 767px) {
            max-width: 300px;
          }
          @media (max-width: 1024px) {
            max-width: 331px;
        }
        }
      }
      .blue-bg {
        background-color: #233354;
        color: #ffffff;
        padding: max(2.083vw, 25px);
        display: grid;
        place-content: center;
        text-align: left;
        @media (max-width: 767px) {
          padding: max(1.083vw, 15px);
        }
        h4 {
          font-size: 34px;
        }
      }
      p {
        max-width: 490px;
        margin-top: 40px;
        @media (max-width:767px){
          padding-top: 0px;
        margin-top: 19px;
        }
      }
      button {
        width: 265px;
        font-weight: 600;
        @media (max-width:767px){
          width: 290px;
        }
      }
      &.mid-part {
        .gry-bg {
          @media (max-width: 767px) {
            grid-row-end: none;
          }
        }
      }
    }
    @media (max-width: 1024px) {
      h4 {
        font-size: 1.5rem;
      }
    }
  }
  h2,
  h3,
  h4 {
    font-family: ITC Franklin Gothic Std;
  }
  .search_marketplace {
    padding: 2vw 16px;
    padding-top: 4vw;
    display: grid;
    justify-content: center;
    text-align: center;
    @media (max-width: 767px) {
      padding: 7vw 16px;
      h4{
        font-size: 32px;
      }
      h2{
        font-size: 1.7rem !important;
        display: contents;
      }
      .experience{
        margin-top: 6px;
      }
    }
    h2 {
      font-family: ITC Franklin Gothic Std;
      color: #233354;
      /* font-size: 2rem; */
    }
    .flex {
      gap: 3vw;
      display: flex;
      margin-top: 30px;
      button {
        background-color: #233354;
        color: rgb(255, 255, 255);
      }
      @media (max-width: 1023px) {
        button {
          width: 215px;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    h2 {
      font-size: 1.7rem;
    }
    h4 {
      font-size: 32px !important;
    }
    li {
      font-size: 14px;
    }
    p {
      font-size: 14px;
    }
  }
`;
const BackButton = styled.button`
  p{
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2.759rem;
    @media (max-width: 767px) {
      h2{
        font-size: 1.5rem !important;
      }
    }
  }
  border: none;
  background: #ffffff;
  position: absolute;
  top: 92px;
  z-index: 9;
  border-radius: 80%;
  height: 32px;
  width: 32px;
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export { Banner, Expertise, Operation, BackButton };
